export const isNullOrEmpty = (value) => {
    return value == null || typeof (value) !== 'string' || value.trim() === '';
};
